import gcImage from '../../../assets/promo/gc.png';
import scImage from '../../../assets/promo/sc.png';
import scAndGcImage from '../../../assets/promo/scAndGc.png';

export function getImageByCoinsType(gcAmount: number, scAmount: number) {
  if (gcAmount > 0 && scAmount > 0) {
    return scAndGcImage;
  } else if (scAmount > 0) {
    return scImage;
  } else if (gcAmount > 0) {
    return gcImage;
  }

  return gcImage;
}
